import { axiosSFS, params } from '@/api/instance'

const getLanguagesByAirlineToken = (request) => {
  const url = axiosSFS.defaults.baseURL + '/airlines/' + request.airline_token + '/langs/' + request.lang_code
  return axiosSFS.get(url).then((response) => {
    let res = response?.data
    if (res?.success) {
      res.data['lang_code'] = request.lang_code
      return res.data
    }
  })
}

const checkAirlineToken = (request) => {
  const url = axiosSFS.defaults.baseURL + '/airlines/checkToken/' + request.airline_token
  return axiosSFS.get(url).then((response) => {
    let res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}
export { getLanguagesByAirlineToken, checkAirlineToken }
